package pl.decks.personal.pages.ievp.sections.profile

import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.times
import pl.decks.personal.styles.SiteLayout

object ProfileSectionStylesheet {
    object Vars {
        val dimensionColor by StyleVariable<Color>()
        val iconSize by StyleVariable<CSSLengthOrPercentageNumericValue>()
        val textSize by StyleVariable<CSSLengthOrPercentageNumericValue>()
        val listingGap by StyleVariable<CSSLengthOrPercentageNumericValue>()
        val textGap by StyleVariable<CSSLengthOrPercentageNumericValue>()
    }

    val RadarContainer = CssStyle.base {
        Modifier.fillMaxWidth().aspectRatio(1).flexShrink(0).flexGrow(0)
    }

    object Legend {
        val Listing = CssStyle.base {
            Modifier.fillMaxWidth().gap(Vars.listingGap.value())
        }

        val Entry = CssStyle.base {
            Modifier
                .fillMaxWidth()
                .color(Vars.dimensionColor.value())
                .fontSize(Vars.textSize.value())
                .gap(Vars.textGap.value())
        }
        val Icon = CssStyle.base {
            Modifier
                .flexShrink(0)
                .whiteSpace(WhiteSpace.NoWrap)
                .fontSize(Vars.iconSize.value())
                .width(Vars.iconSize.value() * 1.5)
                .textAlign(TextAlign.Center)
                .display(DisplayStyle.InlineBlock)
        }
        val DotsContainer = CssStyle.base {
            Modifier
                .flexGrow(1)
                .overflow(Overflow.Hidden)
                .height(Vars.textSize.value())
                .position(Position.Relative)
        }
        val Dots = CssStyle.base {
            Modifier
                .position(Position.Absolute)
                .bottom(SiteLayout.Fraction.none)
                .left(SiteLayout.Fraction.none)
                .whiteSpace(WhiteSpace.NoWrap)
                .letterSpacing(SiteLayout.Offset.Small)
        }
        val Title = CssStyle.base {
            Modifier.whiteSpace(WhiteSpace.NoWrap).flexShrink(0)
        }
    }

}
